import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2fcafd96"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "btn-group mb-3",
  role: "group"
}
const _hoisted_2 = { class: "d-flex flex-wrap" }
const _hoisted_3 = { class: "p-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary btn-sm",
  for: "btncheck1"
}, "Basic", -1))
const _hoisted_5 = { class: "p-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary btn-sm",
  for: "btncheck2"
}, "Stock", -1))
const _hoisted_7 = { class: "p-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary btn-sm",
  for: "btncheck3"
}, "Sales", -1))
const _hoisted_9 = { class: "p-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary btn-sm",
  for: "btncheck4"
}, "Unit Dims", -1))
const _hoisted_11 = { class: "p-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary btn-sm",
  for: "btncheck5"
}, "Inner Dims", -1))
const _hoisted_13 = { class: "p-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary btn-sm",
  for: "btncheck6"
}, "Outer Dims", -1))
const _hoisted_15 = { class: "p-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary btn-sm",
  for: "btncheck7"
}, "Misc.", -1))
const _hoisted_17 = { class: "p-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary btn-sm",
  for: "btncheck8"
}, "Characteristics", -1))
const _hoisted_19 = { class: "p-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary btn-sm",
  for: "btncheck9"
}, "Band Info", -1))
const _hoisted_21 = { class: "p-1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-primary btn-sm",
  for: "btncheck10"
}, "Opt. & Feas.", -1))
const _hoisted_23 = { class: "table-responsive" }
const _hoisted_24 = { class: "table table-striped table-hover table-sm" }
const _hoisted_25 = { class: "pagination mb-0" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "mt-2 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck1",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedViews.basic) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.selectedViews.basic]
          ]),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck2",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedViews.stock) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.selectedViews.stock]
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck3",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedViews.sales) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.selectedViews.sales]
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck4",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedViews.unit) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.selectedViews.unit]
          ]),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck5",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedViews.inner) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.selectedViews.inner]
          ]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck6",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedViews.outer) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.selectedViews.outer]
          ]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck7",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedViews.misc) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.selectedViews.misc]
          ]),
          _hoisted_16
        ]),
        _createElementVNode("div", _hoisted_17, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck8",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedViews.characteristics) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.selectedViews.characteristics]
          ]),
          _hoisted_18
        ]),
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck9",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedViews.band) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.selectedViews.band]
          ]),
          _hoisted_20
        ]),
        _createElementVNode("div", _hoisted_21, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "btn-check",
            id: "btncheck10",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedViews.systems) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.selectedViews.systems]
          ]),
          _hoisted_22
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("table", _hoisted_24, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHeaders, (header, index) => {
              return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(header), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHeaders, (header, idx) => {
                return (_openBlock(), _createElementBlock("td", { key: idx }, _toDisplayString(_ctx.formatValue(item[header])), 1))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("nav", null, [
      _createElementVNode("ul", _hoisted_25, [
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: _ctx.pageIndex <= 1 }])
        }, [
          _createElementVNode("a", {
            class: "page-link transition fw-medium shadow-none text-primary",
            href: "#",
            onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
          }, "Previous")
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (page) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["page-item", { active: page === _ctx.pageIndex }]),
            key: page
          }, [
            _createElementVNode("a", {
              class: "page-link transition fw-medium shadow-none text-primary",
              href: "#",
              onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["prevent"])
            }, _toDisplayString(page), 9, _hoisted_26)
          ], 2))
        }), 128)),
        _createElementVNode("li", {
          class: _normalizeClass(["page-item", { disabled: _ctx.pageIndex >= _ctx.totalPages }])
        }, [
          _createElementVNode("a", {
            class: "page-link transition fw-medium shadow-none text-primary",
            href: "#",
            onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
          }, "Next")
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_27, " Page " + _toDisplayString(_ctx.pageIndex) + " of " + _toDisplayString(_ctx.totalPages), 1)
  ]))
}